import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/user/studio/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/user/studio/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user/studio/src/components/countdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user/studio/src/components/header.tsx");
